import { Component, Inject, OnInit, ViewChild } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialog } from '@angular/material/dialog';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { Router } from '@angular/router';
import { Subject, takeUntil } from 'rxjs';
import { ExecutionQ, ExecutionQFilter } from 'src/app/model/execution';
import { ExecutionQDataSource } from 'src/app/model/executionQDataSource';
import { ExecutionQService } from 'src/app/services/executionQ.service';
import { SpinnerService } from 'src/app/services/spinner.service';
import { ConfirmationDialogComponent } from '../../shared/confirmation-dialog/confirmation-dialog.component';
import { TranslateService } from '@ngx-translate/core';
import { ExecutionReportFilter } from '../../../model/attachment';
import { ExecutionQEditGenerateReportComponent } from '../execution-edit/execution-q-edit-generate-report/execution-q-edit-generate-report.component';


export interface DialogDataExecutionListConfig {
  isList: boolean;
}

@Component({
    selector: 'app-execution-q-list',
    templateUrl: './execution-q-list.component.html',
    standalone: false,
})
export class ExecutionQListComponent implements OnInit {

  @ViewChild(MatSort, { static: true }) sort: MatSort;
  @ViewChild(MatPaginator) paginator: MatPaginator;

  filter: ExecutionQFilter = new ExecutionQFilter();
  hasFiltered = false;
  dataSource: ExecutionQDataSource;

  displayedColumns = ['documentCode', 'projectNo', 'client',  'equipment', 'status', 'realizationDate', 'download', 'edit', 'delete'];

  private destroy$ = new Subject<void>();

  constructor(
    private executionService: ExecutionQService,
    private router: Router,
    private translate: TranslateService,
    private dialog: MatDialog,
    private spinnerService: SpinnerService,
    
    @Inject(MAT_DIALOG_DATA) public data: DialogDataExecutionListConfig
  ) {
    if (data.isList == null) {
      data.isList = true;
    }
  }

  ngOnInit(): void {
    this.loadExecutionList();
  }

  doFilter(event: ExecutionQFilter): void {
    this.filter = event;

    this.hasFiltered = true;

    this.loadExecutionList();
  }

  loadExecutionList(): void {
    this.dataSource = new ExecutionQDataSource(this.executionService);

    this.filter.sortBy = this.sort.active || 'documentCode';
    this.filter.sortDirection = this.sort.direction || 'desc';
    this.filter.pageIndex = this.paginator?.pageIndex || 0;
    this.filter.pageSize = this.paginator?.pageSize || 10;
    if (this.hasFiltered) {
      this.saveSearchFilter(this.filter);
      this.dataSource.loadExecution(this.filter);
    }
    this.dataSource.loading$.pipe(takeUntil(this.destroy$)).subscribe(message => this.spinnerService.next(message));
  }

  saveSearchFilter(execution: ExecutionQFilter): void {
    localStorage.setItem('filter', JSON.stringify(execution));
  }

  canClone(ex: ExecutionQ): boolean {
    return false;
  }

  deleteRow(id: number): void {
    if (id < 0) {
      return;
    }
    const message = this.translate.instant('executionEditQ.form.execution.delete') as string;
    
    const dialogRef = this.dialog.open(ConfirmationDialogComponent, { data: { message } });

    dialogRef.afterClosed().pipe(takeUntil(this.destroy$)).subscribe(response => {
      if (response) {
        this.spinnerService.show();

        this.executionService.delete(id).pipe(takeUntil(this.destroy$)).subscribe(() => {
          this.spinnerService.hide();
          this.loadExecutionList();
        });
      }
    });

    
  }

  editRow(id: number): void {
    void this.router.navigateByUrl(`/qualificates/execution?id=${id}`);
  }

  new(): void {
    void this.router.navigateByUrl('/qualificates/execution?id=0');
  }

  downloadPdf(execution: ExecutionQ): void {
    const dialogRef = this.dialog.open(ExecutionQEditGenerateReportComponent, {
      minWidth: '40%',
      maxHeight: '95vh',
      data: {
        execution,
        reason: execution.reason
      }
    });

    dialogRef.afterClosed().pipe(takeUntil(this.destroy$)).subscribe((result: ExecutionReportFilter) => {
      if (result != null) {
        this.loadExecutionList();
      }
    });
  }
}
